import { Vector3 } from 'three';

/**
 * Source uses a Z-up, right-handed coordinate system (X east, Y north, Z up) at
 * 1 unit = 1 inch. Fall Line is Y-up with the SAME unit scale (1 unit = 1 Hammer
 * unit = 1 Source unit — our player capsule 72×16 is the Source player), so the
 * only conversion is an axis swap: (x, y, z)_src → (x, z, -y)_world.
 *
 * That swap flips handedness, so triangle winding must be reversed to keep face
 * normals pointing the same way (handled where geometry is built). This module is
 * the single source of truth for the swap, used by every geometry/entity path.
 */

export function srcToWorld(x: number, y: number, z: number): Vector3 {
  return new Vector3(x, z, -y);
}

export function srcArrToWorld(v: readonly [number, number, number]): Vector3 {
  return new Vector3(v[0], v[2], -v[1]);
}

/** Source yaw (degrees about Z, 0 = +X) → our view yaw (radians, 0 = -Z). */
export function srcYawToWorld(yawDeg: number): number {
  // Source forward at yaw φ is (cos φ, sin φ, 0) → world (cos φ, 0, -sin φ).
  // Our camera forward at yaw θ is (-sin θ, 0, -cos θ). Solve: θ = φ + 90°.
  return ((yawDeg + 90) * Math.PI) / 180;
}
